/*********************************************************
 * Imports third Controls
 *********************************************************/
import React, { Fragment, useEffect, useState } from "react";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'; //faSortDown


/*********************************************************
 * Components / Controls
 *********************************************************/

import GroupItem from './GroupItem'
import InputSearch from '../../components/InputSearch'
import Loading from 'Components/Loading'
import { Grid, IconButton, Icon } from '@mui/material';
import { Tooltip, ToggleSwitch } from 'Components';

import InfiniteScroll from "react-infinite-scroll-component";

/*********************************************************
 * Styles
 *********************************************************/
import './style.scss'
import GroupListSearch from "./GroupListSearch";
import { getUnitsNaturalOrder } from "../../core/data/Helpers";

/*********************************************************
 * Control to List Header
 *********************************************************/
const GroupsListHeader = (props) => {
  return (
    <div className={'groupListHeaderClass'} {...props}>
      {props.children}
    </div>
  )
}

/*********************************************************
 * Control to Header Item
 *********************************************************/
const HeaderItem = (props) => {
  return (
    <div className={'headerItemClass'} {...props}>
      {props.children}
    </div>
  )
}

/*********************************************************
 * Control to Actions Button
 *********************************************************/
const ActionsButton = (props) => {
  return (
    <HeaderItem>
      <div className={'actionButtonClass'} {...props}>
        {props.children}
      </div>
    </HeaderItem>
  )
}

/********************************************************
 * Global vars
 ********************************************************/
let timerCountSearchControl = null

/*********************************************************
 * Class associated to the google map provider
 ********************************************************/
const GroupsList = (props) => {

  const {
    groupsData,
    detailData,
    messages,
    showActions,
    showSearch,
    messageNoItems,
    onClickSettings,
    settingsTooltipText,
    listWithoutItems,
    delaySeconds = 1000,
    useDelay = false,
    loading = false,
    offset,
    itemsPerPage,
    totalItems,
    height,
    expandAllProp,
    clearFilterAfterAction } = props

  // -------------- declare State -----------------
  const [filter, setFilter] = useState('')
  const [groupItems, setGroupItems] = useState([])
  const [itemsDetail, setItemsDetail] = useState([])
  const [expandAll, setExpandAll] = useState(null)

  const pageSize = 500; // Number of elements to load each time
  const [visibleGroups, setVisibleGroups] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [flattenedData, setFlattenedData] = useState([]);
  const [visibleCount, setVisibleCount] = useState(pageSize); // Start with 500 elements
  


  /*********************************************************
  * Save the event after 1 seconds start at the last event make 
  * from the user UI
  *********************************************************/
  const validateLastEvent = (paramFilter) => {
    if (timerCountSearchControl) {
      clearInterval(timerCountSearchControl)
    }
    timerCountSearchControl = setInterval(newEventFuction(paramFilter), delaySeconds)
  }

  /*********************************************************
  * Call the save preferences and restart the timer
  *********************************************************/
  const newEventFuction = (paramFilter) => {
    clearInterval(timerCountSearchControl)
    timerCountSearchControl = null
    if (props.onSearchWhenFinish) {
      props.onSearchWhenFinish(paramFilter)
    }
  }

  /*********************************************************
  * Event to Group Check Change
  *********************************************************/
  const onGroupCheckChanged = (groupId, checked) => {
    if (props.onGroupCheckChanged) {
      props.onGroupCheckChanged(groupId, checked)
    }
  }

  /*********************************************************
  * Event item list click
  *********************************************************/
  const onItemClicked = (item, highlight) => {
    if (props.onItemClicked) {
      props.onItemClicked(item, highlight)
    }
  }

  /*********************************************************
  * return the props event onActionsClicked
  *********************************************************/
  const onActionsClicked = () => {
    if (props.onActionsClicked) {
      props.onActionsClicked()
    }
  }

  /*********************************************************
  * Update the groups items when the control load information
  *********************************************************/
  useEffect(() => {
    if (groupsData) {
      setGroupItems(groupsData)
    }
    if (detailData) {
      setItemsDetail(detailData)
    }
  }, [])

  /*********************************************************
  * Set the default value to expandALL preference prop
  *********************************************************/
  useEffect(() => {
    if (expandAllProp) {
      setExpandAll(expandAllProp)
    }
  }, [expandAllProp])

  /*********************************************************
  * Update the groups items when the data is updated
  *********************************************************/
  useEffect(() => {
    setGroupItems(groupsData)
  }, [groupsData])

  /*********************************************************
  * Update the details items when the data is updated
  *********************************************************/
  useEffect(() => {
    setItemsDetail(detailData)
  }, [detailData])

  /*********************************************************
  * Return the event when the user make the search
  *********************************************************/
  const onSearchWhenFinish = (param) => {
    setFilter(param)
    if (useDelay) {
      //Start delay elements
      validateLastEvent(param)
    } else {
      if (props.onSearchWhenFinish) {
        props.onSearchWhenFinish(param)
      }
    }
  }

  /*********************************************************
  * when the user click on the title to perform get data
  * load data on Demand
  *********************************************************/
  const onTitleContainerClicked = (id, expanded) => {
    if (props.onTitleContainerClicked) {
      props.onTitleContainerClicked(id, expanded)
    }
  }

  /*********************************************************
  * Expand or collapse the menu elements
  *********************************************************/
  const onExpanded = (id, expanded) => {
    if (props.onExpanded) {
      props.onExpanded(id, expanded)
    }
  }

  if (!groupItems) {
    return <div></div>
  }

  useEffect(() => {
    if(clearFilterAfterAction){
      setFilter('')
    }
  }, [clearFilterAfterAction])


  /*********************************************************
   * Replacement of the filter element definitions to avoid infinite re-renders
   * Removes the current definitions of elementsFilterTag, elementsFilterDetail, 
   * elementsFilterTagWithChildren, and elementsFilter
   * and replaces them with a memoized version using useMemo
   *********************************************************/
  const elementsFilter = React.useMemo(() => {
    // Pre-sort items for each group so we don't call getUnitsNaturalOrder during render
    const sortItems = (groups) => groups.map(g => ({
      ...g,
      items: g?.items ? getUnitsNaturalOrder(g.items) : []
    }));

    const elementsFilterTag = filter ? groupItems.filter(({ name }) => 
      name?.toLocaleLowerCase().includes(filter?.toLocaleLowerCase())
    ) : groupItems;
    
    const elementsFilterDetail = filter ? groupItems.map(element => {
      const filterSubItems = element?.items?.filter(({ name }) => 
        name?.toLocaleLowerCase().includes(filter?.toLocaleLowerCase())
      );
      if (filterSubItems?.length) {
        return { ...element, items: filterSubItems };
      }
      return null;
    }).filter(item => item !== null) : groupItems;
    
    const elementsFilterTagWithChildren = elementsFilterTag.map(element => ({
      ...element,
      items: element?.open ? (element.items || []) : []
    }));
    
    if (filter) {
      return sortItems([
        ...elementsFilterTagWithChildren,
        ...elementsFilterDetail.filter(detailElement => 
          !elementsFilterTag.some(tagElement => tagElement.name === detailElement.name)
        )
      ]);
    }
    return sortItems(groupItems);
  }, [filter, groupItems]);

  /*********************************************************
   * Flatten groups and items for pagination
   * Returns an array where each group and its items are represented as separate entries
   * If a group is expanded (open), its items are included in the flattened array
   * Each entry has a type ('group' or 'item'), groupId, itemId (null for groups), and data
   * Example output:
   * [
   *   { type: 'group', groupId: 1, itemId: null, data: { ...groupData } },
   *   { type: 'item', groupId: 1, itemId: 101, data: { ...itemData }, parentGroup: { ...groupData } },
   *   { type: 'item', groupId: 1, itemId: 102, data: { ...itemData }, parentGroup: { ...groupData } },
   *   { type: 'group', groupId: 2, itemId: null, data: { ...groupData } },
   *   ...
   * ]
   *********************************************************/
  const flattenGroupsAndItems = (groups) => {
    const flattened = [];
    
    groups.forEach(group => {
      // Add the group itself
      flattened.push({
        type: 'group',
        groupId: group.id,
        itemId: null,
        data: group
      });
      
      // If group is open, add all its items
      if (group?.open && group?.items && group.items.length > 0) {
        group.items.forEach(item => {
          flattened.push({
            type: 'item',
            groupId: group.id,
            itemId: item.id,
            data: item,
            parentGroup: group
          });
        });
      }
    });
    
    return flattened;
  };


/*********************************************************
   * Reconstruct groups structure from flattened array
   * Takes a flattened array of groups and items and reconstructs the original nested structure
   * Groups are identified by their groupId, and items are associated with their parent group
   * If a group is expanded (open), its items are included in the reconstructed group
   * Example input:
   * [
   *   { type: 'group', groupId: 1, itemId: null, data: { ...groupData } },
   *   { type: 'item', groupId: 1, itemId: 101, data: { ...itemData }, parentGroup: { ...groupData } },
   *   { type: 'item', groupId: 1, itemId: 102, data: { ...itemData }, parentGroup: { ...groupData } },
   *   { type: 'group', groupId: 2, itemId: null, data: { ...groupData } },
   *   ...
   * ]
   *********************************************************/
const reconstructGroups = (flattenedArray) => {
  const groupsMap = new Map();
  
  flattenedArray.forEach(element => {
    if (element.type === 'group') {
      // Create group with empty items initially
      if (!groupsMap.has(element.groupId)) {
        groupsMap.set(element.groupId, {
          ...element.data,
          items: element.data?.open ? [] : (element.data?.items || [])
        });
      }
    } else if (element.type === 'item') {
      // Add item to its parent group
      if (!groupsMap.has(element.groupId)) {
        groupsMap.set(element.groupId, {
          ...element.parentGroup,
          items: []
        });
      }
      const group = groupsMap.get(element.groupId);
      if (group.open) {
        group.items.push(element.data);
      }
    }
  });
  
  return Array.from(groupsMap.values());
};



/*********************************************************
   * Use effect to handle pagination after elementsFilter
   * If a filter is applied, show all matching elements without pagination
   * If no filter is applied, flatten the groups and items, then paginate the results
   * Initially show 'visibleCount' elements, and load more as needed
   * Updates visibleGroups and hasMore state based on current filter and pagination
*********************************************************/
useEffect(() => {
  if (filter) {
    // With filter: show all elements
    setVisibleGroups(elementsFilter);
    setHasMore(false);
  } else {
    // Without filter: flatten and paginate
    const flattened = flattenGroupsAndItems(elementsFilter);
    setFlattenedData(flattened);
    
    // Take first 'visibleCount' elements
    const visibleFlattened = flattened.slice(0, visibleCount);
    const reconstructed = reconstructGroups(visibleFlattened);
    
    setVisibleGroups(reconstructed);
    setHasMore(visibleCount < flattened.length);
  }
}, [elementsFilter, filter, visibleCount]);


/*********************************************************
   * Function to load more data when user scrolls
   * If no filter is applied and there are more elements to show,
   * increases the visibleCount by pageSize to load more elements
*********************************************************/
const fetchMoreData = () => {
  if (!filter && flattenedData.length > visibleCount) {
    // Load pageSize more elements
    setVisibleCount(prevCount => prevCount + pageSize);
  }
};

  return (
    <Fragment>
      <GroupsListHeader>
        {showActions && <ActionsButton onClick={onActionsClicked}>ACTIONS <ArrowDropDownIcon style={{ marginTop: -5 }}></ArrowDropDownIcon></ActionsButton>}

        {
          showSearch
          &&
          <InputSearch
            noWhiteSpace
            searchText={filter}
            onSearch={(param) => setFilter(param)}
            searchWhenFinishedTyping={true}
            onSearchWhenFinish={onSearchWhenFinish}
            className={props?.classNameInputSearch || ''}
          />
        }

        {
          !loading
          &&
          onClickSettings
          &&
          <div className={'butSettings'}>
            <Tooltip title={settingsTooltipText} placement={'top-start'}>
              <IconButton
                aria-haspopup="true"
                onClick={onClickSettings}
                color="inherit"
                size="large">
                <Icon>{'settings'}</Icon>
              </IconButton>
            </Tooltip>
          </div>
        }

        {
          loading
          &&
          <div style={{ paddingLeft: 20 }}>
            <Loading />
          </div>
        }
      </GroupsListHeader>

      {
        props.children
      }

      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        style={{
          marginBottom: 10
        }}
      >
        <Grid item xs>
          {props.renderActions}
        </Grid>

        <Grid item xs style={{ textAlign: 'right' }}>
          {
            props?.isExpandAll
            &&
            <ToggleSwitch
              id={'gListExpandAll'}
              mapToggle
              xLarge
              optionLabels={[messages['expandAll'], messages['expandAll']]}
              checked={expandAll || false}
              onChange={(checked) => {
                setExpandAll(checked)
                if (props.onExpandSwitchAll)
                  props.onExpandSwitchAll(checked)
              }}
            />
          }
        </Grid>
      </Grid>

      {
        props.onSearchWhenFinish
        &&
        filter
        &&
        <GroupListSearch
          data={itemsDetail}
          offset={offset}
          itemsPerPage={itemsPerPage}
          totalItems={totalItems}
          onNewDataPagination={props.onNewDataPagination}
          onClickListSearchItem={props.onClickListSearchItem}
          height={height}
          messages={messages} />
      }

      <div
        id="scrollableDiv"
        style={{
          paddingTop: 20,
          overflowY: filter ? (props.overflowY || "auto") : "auto",
          overflowX: props.overflowX || "hidden", 
          height: props.bodyHeight || "calc(100vh - 300px)"
        }}
      >
        {
          (!props.onSearchWhenFinish) && (
            filter ? (
              // If there is a filter, show all elements without InfiniteScroll
              elementsFilter?.map((group, index) => (
                <GroupItem
                  {...group}
                  items={group?.items}
                  displayCheckOnItems
                  expanded={group?.open}
                  highlightId={props.highlightId}
                  defaultExpanded={props.defaultExpanded}
                  key={`${index}-${group.id}`}
                  filter={filter}
                  onItemClicked={onItemClicked}
                  onGroupCheckChanged={onGroupCheckChanged}
                  onTitleContainerClicked={onTitleContainerClicked}
                  onExpanded={onExpanded}
                  restart={props.restart}
                  loading={loading || false}
                  messageNoItems={messageNoItems}
                  highlightMessage={props.highlightMessage}
                  noClickEventMessage={props.noClickEventMessage}
                  renderItemActions={props.renderItemActions}
                  onMouseEnter={props.onMouseEnter}
                  onMouseLeave={props.onMouseLeave}
                />
              ))
            ) : (
              // If there is no filter, use InfiniteScroll
              <InfiniteScroll
                dataLength={visibleGroups.length}
                next={fetchMoreData}
                hasMore={hasMore}
                //loader={<div style={{ textAlign: 'center', padding: 20 }}>{messages?.['loading'] || 'Loading...'}</div>}
                scrollableTarget="scrollableDiv"
                /* endMessage={
                  <div style={{ textAlign: 'center', padding: 20 }}>
                    <b>{messages?.['noMoreItems'] || 'No more items'}</b>
                  </div>
                } */
              >
                {visibleGroups?.map((group, index) => (
                  <GroupItem
                    {...group}
                    items={group?.items}
                    displayCheckOnItems
                    expanded={group?.open}
                    highlightId={props.highlightId}
                    defaultExpanded={props.defaultExpanded}
                    key={`${index}-${group.id}`}
                    filter={filter}
                    onItemClicked={onItemClicked}
                    onGroupCheckChanged={onGroupCheckChanged}
                    onTitleContainerClicked={onTitleContainerClicked}
                    onExpanded={onExpanded}
                    restart={props.restart}
                    loading={loading || false}
                    messageNoItems={messageNoItems}
                    highlightMessage={props.highlightMessage}
                    noClickEventMessage={props.noClickEventMessage}
                    renderItemActions={props.renderItemActions}
                    onMouseEnter={props.onMouseEnter}
                    onMouseLeave={props.onMouseLeave}
                  />
                ))}
              </InfiniteScroll>
            )
          )
        }
      </div>

      <div style={{ paddingTop: 20 }}>
        {
          !props.onSearchWhenFinish
          &&
          listWithoutItems
          &&
          listWithoutItems?.map((group, index) => {
            return <GroupItem
              {...group}
              key={`${index}-${group.id}`}
              filter={filter}
              messageNoItems={messageNoItems}
              noClickEventMessage={props.noClickEventMessage} />
          })
        }
      </div>
    </Fragment>
  );

}

export default GroupsList